import React, { Component } from 'react';
import config from 'react-global-configuration';

import Select from 'react-select';
import InputMask from 'react-input-mask';

import { Modal } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class DrowsinessScheduleTestTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      staff_list: [],
      id: this.props.drowsiness_schedule_id,
      drowsiness_schedule_status: this.props.drowsiness_schedule_status,
    };

    this.editTest = this.editTest.bind(this);
    this.showModal = this.showModal.bind(this);
    this.deleteTest = this.deleteTest.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);

    //Handlers
    this.locale = getLocale();

  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.drowsiness_schedule_id !== 'undefined' && Array.isArray(newProps.drowsiness_schedule_tests)) {
      this.setState({
        id: newProps.drowsiness_schedule_id,
        staff_list: newProps.staff_list,
        drowsiness_schedule_tests: newProps.drowsiness_schedule_tests,
        drowsiness_schedule_status: newProps.drowsiness_schedule_status,
      });
    }
  }

  // Fetch salvando a edição
  editTest(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.drowsiness_schedule_test_id,
      staff_id: this.state.staff_id,
      date: this.state.date,
      hours: this.state.hours,
    };
    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/sonolencia/teste', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.props.updateData(responseJson);
        }
        
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteTest (event) {
    var drowsiness_schedule_test_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.deletarColaboradorDaEscalaDeTeste);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/sonolencia/teste/' + drowsiness_schedule_test_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  showModal(event) {
    var self = this;
    var drowsiness_schedule_test_id = event.currentTarget.value;

    var data = self.state.drowsiness_schedule_tests;
    data.map(function(dado, index){
      if (dado.id == drowsiness_schedule_test_id) {
        self.setState({
          staff_id: dado.staff_id,
          date: dado.date_str,
          hours: dado.hours,
          drowsiness_schedule_test_id: dado.id,
          modal: true,
        });
      }
    });
  }
  ActionsButtons (cell, row) { 
    var botao_disabled = (
      <div className="btn-group">
        <button className="btn btn-primary btn-sm" disabled value={cell} onClick={this.showModal}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
        <button className="btn btn-sm btn-danger" disabled value={cell} onClick={this.deleteTest}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );
    var botao = (
      <div className="btn-group">
        <button className="btn btn-primary btn-sm" value={cell} onClick={this.showModal}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.deleteTest}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    ); 
    {this.state.drowsiness_schedule_status !== 'rascunho' ? 
      botao_disabled
      :
      botao
    }

    return botao;
  }
  
  render() {
    return (
<div>
  <h3>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tituloTestesDeEscalaDeSonolencia}</h3>
  <div className="clearfix"></div>
  <hr/>
  <BootstrapTable data={this.state.drowsiness_schedule_tests} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tabela.semColaboradores}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tabela.ID}</TableHeaderColumn>

    <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tabela.Colaborador}</TableHeaderColumn>

    <TableHeaderColumn dataField="date_hours" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tabela.ProgramacaoDeEnvio}</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tabela.Acoes}</TableHeaderColumn>

  </BootstrapTable>
      <Modal show={this.state.modal} bsSize={'large'} aria-labelledby="contained-modal-title-lg">
        <Modal.Header>
          <h4 className="pull-left">{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tituloEditarTeste}</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.editTest}> 
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.Data}:</label>
                  <InputMask value={this.state.date} required maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.HorariosDeEnvio}:</label>
                  <InputMask required value={this.state.hours} maskChar={null} name="hours" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'hours')} placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.placeholder.SelecionarAplicabilidade} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.Colaborador}:</label>
                  <Select
                    className="form-field-name"
                    name="staff_id"
                    value={this.state.staff_id}
                    searchable={true}
                    placeholder={this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.placeholder.SelecionarAplicabilidade}
                    onChange={this.handleSelectChange.bind(this, 'staff_id')}
                    options={this.state.staff_list}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.botaoSalvarEdicao}</button>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
</div>
    );
  }
}

export default DrowsinessScheduleTestTab;



// WEBPACK FOOTER //
// ./src/Components/DrowsinessSchedules/Elements/DrowsinessScheduleTestTab.js